// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import axios from 'axios'
import APIJS from './API.js'
import Global from './Global.js'
import GoogleMap from './GoogleMap.js'
import LeafletMap from './LeafletMap.js'
import Vehicle from './Vehicle.js'
import History from './History.js'
import SignalR from './SignalR.js'
import Report from './Report.js'
import Manage from './Manage.js'
import VueCookie from 'vue-cookie'
import $ from "jquery";
import moment from "moment";
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
const options = {
    // You can set your default options here
};
Vue.use(Toast, options);
Vue.use(VueCookie)   // 掛在在全域性了
Vue.use(APIJS);
Vue.use(Global);
Vue.use(GoogleMap);
Vue.use(LeafletMap);
Vue.use(Vehicle);
Vue.use(History);
Vue.use(SignalR);
Vue.use(Report);
Vue.use(Manage);
Vue.prototype.$axios = axios
Vue.prototype.$=$
Vue.prototype.moment = moment
Vue.use(BootstrapVue)
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  methods:{
    //重置歷史軌跡資訊
    ResetHistory(){
      this.$History.VideoObjectShow = false
      this.$History.UnitDateTimeHistoryObj = ''
      this.$History.FleetID = 0
      this.$History.HUnitid = 0
      this.$History.UnitArr = []
      this.$History.HStartTime = '00:00'
      this.$History.HEndTime = '23:59'
      // this.$History.HStartdate = this.$Global.getToday()
      // this.$History.HEnddate = this.$Global.getToday()
      this.$History.StopTrackHistory()
      clearInterval(this.$History.PlayNextIntervalID)
      clearInterval(this.$History.RewindIntervalID)
      this.$History.PlayNextIntervalID = ''
      this.$History.RewindIntervalID = ''
      this.$History.PlayBackData = ''
      this.$History.HistoryPageNum = 0
      this.$History.CurrentHistoryPage = 0
      //刪除大數據打點 Canvas
      if(this.$Global.MapType == 'Leaflet'){
        if(this.$LeafletMap.ciLayer != ''){
          this.$LeafletMap.RemoveciLayer()
        }
        if(this.$LeafletMap.AccOnOffciLayer != ''){
          this.$LeafletMap.RemoveAccOnOffciLayer()
        }
      } 
    }
  },
  watch: {
    $route(to, from) {
      this.$Vehicle.UnitListDetailShow = false//關閉UnitDetail
      this.$Vehicle.CommandShow = false //關閉Command
      this.$Vehicle.CloseVideo()//關閉Video視窗
      this.$Global.Noneactive = ''//開啟網頁操作     
      switch (from.name) {
        case 'Vehicle':
          // this.$SignalRjs.ConnectionStop()//關閉SignalR
          break;
        case 'History':
          this.ResetHistory()
          break;
        case 'Manage':
          break;
        case 'Report':
          break;
        case 'Dashboard':
          this.$Global.DashBoardTime = ' 00:00:00'
          // this.$Global.DashBoardFleetID = 0
          break;   
        default:
          break;
      }
      switch (to.name) {
        case 'Vehicle':
          if(this.$Vehicle.MultiViewChckbox){
            this.$Vehicle.MultiViewChckbox = false
            this.$Vehicle.MultiIconcheckbox = 'Iconcheckbox'
            this.$Vehicle.SingleMapShow = true
          }
          this.$Global.load = true
          this.$Global.Noneactive = 'None-active'//關閉網頁操作
          //SignalR 連接
          // this.$SignalRjs.ConnectionSignalR()
          //等待SignalR 連接
          // setTimeout(() => {
          //   this.$Vehicle.SearchCarNum++
          //   // console.log('SearchCarNum++')
          // }, 5000);
          break;
        case 'History':
          break;
        case 'Manage':
          if(from.path.search('Manage') != -1){
            this.$router.push({ name: from.name })
          }
          break;
        case 'Report':
          if(from.path.search('Report') != -1 && from.name != 'MaintanceReport'){
            this.$router.push({ name: from.name })
          }
          break;  
        default:
          break;
      }
      if(to.name == 'Login'){
        this.$cookie.set('ul', null, { path: '/' })
        // window.location.href = window.location.href + "?timestamp=" + new Date().getTime();
        this.$Global.SetlocalStorage()
        // window.location.href = jsonObject['LoginCenter']+jsonObject['SolutionName']+'&Type=Logout'
        this.$Global.Logout('Logout')
      }
      // console.log(localStorage.getItem('token'))
      if((localStorage.getItem('token') == null || localStorage.getItem('token')=='') && to.name!='Setting' && to.name!='Login'){
        // this.$router.push({ name: 'Login' })
        // history.go(0)
        // location.reload(true);
        // window.location.href = window.location.href + "?timestamp=" + new Date().getTime();
        // window.location.href = jsonObject['LoginCenter']+jsonObject['SolutionName']+'&Type=Login'
        this.$Global.Logout('Login')
      }
      else{
        if(this.$Global.CurrentPage == 'Vehicle' || this.$Global.CurrentPage == 'History' || this.$Global.CurrentPage == 'Event' || this.$Global.CurrentPage == 'Video'){
          this.$Global.LogMapPosition(this.$Global.CurrentPage)//紀錄經緯度及放大度
        }
        if(this.$Global.CurrentPage == 'Manage'){
          switch (to.name) {//Manage 切換頁
            case 'UDIDManage':
              this.$Global.managepage = 1
              break;
            case 'BasicDataManage':
              this.$Global.managepage = 2
              break; 
            case 'MaintanceList':
              this.$Global.managepage = 4
              break;
            case 'MaintanceReport':
              this.$Global.managepage = 5
              break;
            case 'ManageGroup':
              this.$Global.managepage = 7
              break;
            case 'ManageAccount':
              this.$Global.managepage = 8
              break;
            case 'ManageVehicle':
              this.$Global.managepage = 9
              break;
            case 'ManageDriver':
              this.$Global.managepage = 10
              break; 
            case 'ManagePOI':
              this.$Global.managepage = 12
              break;    
            case 'ManageGeofence':
              this.$Global.managepage = 13
              break; 
            case 'ManageGeofenceAssign':
              this.$Global.managepage = 14
              break;
            case 'ManageFleetATCommand':
              this.$Global.managepage = 15
              break;  
            case 'BatchCommand':
              this.$Global.managepage = 16
              break; 
            case 'FunctionAuthoritySetting':
              this.$Global.managepage = 18
              break; 
            case 'MaintenanceSchedule':
              this.$Global.managepage = 19
              break; 
            case 'ManageLineBinding':
              this.$Global.managepage = 20
              break; 
            case 'FleetEventSetup':
              this.$Global.managepage = 22
              break;
            case 'ManageVehicle_New':
              this.$Global.managepage = 23
              break; 
              //加管理步驟 8 記錄目前頁面
            case 'ManageLineBindingGroup':
              this.$Global.managepage = 24
              break;              
            default:
              break;
          }
        }
        if(this.$Global.CurrentPage == 'Report'){
          //離開AutoEmail 清掉AutoEmailInputObj
          if(from.name == 'AutoEmail'){
            this.$Report.AutoEmailInputObj = ''
          }
          switch (to.name) {//Report 切換頁
            case 'PositionLogDetail':
              this.$Global.managepage = 1
              break;
            case 'TripDetail':
              this.$Global.managepage = 2
              break;
            case 'CombolEventDetail':
              this.$Global.managepage = 4
              break;
            case 'AlertEventDetail':
              this.$Global.managepage = 5
              break;
            case 'TripSummary':
              this.$Global.managepage = 6
              break;
            case 'MileageDaySummary':
              this.$Global.managepage = 7
              break;
            case 'MileageMonthSummary':
              this.$Global.managepage = 8
              break;
            case 'FuelEstimationMonthSummary':
              this.$Global.managepage = 9
              break;  
            case 'EventSummary':
              this.$Global.managepage = 10
              break;
            case 'VehicleAliveReport':
              this.$Global.managepage = 11
              break;
            case 'ShippingDailyReport':
              this.$Global.managepage = 13
              break;    
            case 'AutoEmail':
              this.$Global.managepage = 16
              break;  
            case 'BackupFilesDownload':
              this.$Global.managepage = 17
              break;  
            case 'DaysOfUseMonthSummary':
              this.$Global.managepage = 18
              break; 
            case 'LoginHistoryDetail':
              this.$Global.managepage = 19
              break; 
            case 'WorkTimeDaySummary':
              this.$Global.managepage = 20
              break; 
            case 'WorkTimeMonthSummary':
              this.$Global.managepage = 21
              break;
            case 'ColdChainTemperatureReport':
              this.$Global.managepage = 22
              break; 
            case 'CANGODetail'://加報表步驟 8 記錄目前頁面
              this.$Global.managepage = 23
              break; 
            case 'CANVOTADetail':
              this.$Global.managepage = 24
              break; 
            default:
              break;
          }
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js